import * as geom from "js/core/utilities/geom";
import { CollectionElement, CollectionItemElement } from "js/elements/base/CollectionElement";
import { TextElement } from "js/elements/base/TextElement";
import { SVGCircleElement } from "js/elements/base/SVGElement";
import { _ } from "js/vendor";
import * as venn from "vendor/d3.venn.js";

class VennDiagram extends CollectionElement {
    getChildItemType() {
        return VennDiagramItem;
    }

    get defaultItemData() {
        return {
            x: 50,
            y: 50,
            radius: 30,
            label: { text: "" },
        };
    }

    _calcProps(props, options) {
        let { size, children, styles } = props;

        let outerBounds;

        for (let item of this.itemElements) {
            // store props for computeTextCentre function
            item.x = (item.model.x || 20) * size.width / 100;
            item.y = (item.model.y || 20) * size.height / 100;
            item.radius = this.calcRadius(item.currentRadius, size);

            let itemSize = new geom.Size(item.radius * 2, item.radius * 2);

            let labelSize = item.label.calcProps(itemSize).size;
            let otherItems = _.filter(this.itemElements, circle => circle !== item);
            let labelCenter = venn.computeTextCentre([item], otherItems);

            if (labelCenter.margin * -0.5 > labelSize.width) {
                labelCenter.x = item.x;
                labelCenter.y = item.y;
            }
            labelCenter.x -= item.x - item.radius + labelSize.width / 2;
            labelCenter.y -= item.y - item.radius + labelSize.height / 2;

            let itemProps = children.setProps(item, new geom.Size(item.radius * 2, item.radius * 2), { labelCenter });
            itemProps.bounds = new geom.Rect(item.x - item.radius, item.y - item.radius, itemProps.size);

            // item.label.bounds = new geom.Rect(labelCenter.x, labelCenter.y, labelSize);

            if (outerBounds) {
                outerBounds = outerBounds.union(itemProps.bounds);
            } else {
                outerBounds = itemProps.bounds;
            }
        }

        this.offsetX = size.width / 2 - outerBounds.width / 2 - outerBounds.left;
        this.offsetY = size.height / 2 - outerBounds.height / 2 - outerBounds.top;

        for (let item of this.itemElements) {
            item.calculatedProps.bounds = new geom.Rect(item.x - item.radius + this.offsetX, item.y - item.radius + this.offsetY, item.radius * 2, item.radius * 2);
        }

        props.isFit = this.itemCount <= (this.styles.maxItemCount || 5);
        return { size };
    }

    calcRadius(radius, size) {
        return radius * (size.height / 2 + size.width / 3.6) / 100;
    }
}

class VennDiagramItem extends CollectionItemElement {
    get selectionPadding() {
        return 0;
    }

    get currentRadius() {
        if (this.canvas.isAnimating) {
            return this.model.radius * this.animationState.value;
        }

        return this.model.radius;
    }

    _build() {
        this.circle = this.addElement("circle", () => SVGCircleElement);
        this.label = this.addElement("label", () => TextElement, {
            model: this.model,
            autoWidth: true,
            autoHeight: true,
            scaleTextToFit: true
        });
    }

    _calcProps(props, options) {
        let { size, children, styles } = props;

        children.setProps(this.circle, {
            bounds: new geom.Rect(0, 0, size),
        });

        let labelProps = children.setProps(this.label, size);
        // labelProps.bounds = new geom.Rect(options.labelCenter.x - labelProps.size.width / 2, options.labelCenter.y - labelProps.size.height / 2, labelProps.size);
        labelProps.bounds = new geom.Rect(options.labelCenter.x, options.labelCenter.y, labelProps.size);

        // let color;
        // if (this.model.color) {
        //     color = app.currentTheme.palette.getColor(this.model.color);
        // } else {
        //     color = this.getSlideColor({ shading: true });
        // }
        //
        // let styles = this.styles.shape;
        // if (styles.fillColor !== "none") {
        //     styles.fillColor = color.toRgbString();
        // }
        // if (styles.strokeColor !== "none") {
        //     styles.strokeColor = color.toRgbString();
        // }

        // this.circle.styles = styles;
        // this.label.styles = this.styles.label;

        return { size };
    }

    get animationElementName() {
        return `Bubble #${this.itemIndex + 1}`;
    }

    _getAnimations() {
        return [{
            name: "Grow in",
            prepare: () => {
                this.label.animationState.fadeInProgress = 0;
                this.animationState.fadeInProgress = 0;
                this.animationState.value = 0;
            },
            onBeforeAnimationFrame: progress => {
                this.label.animationState.fadeInProgress = Math.clamp((progress - 0.7) / 0.3, 0, 1);
                this.animationState.fadeInProgress = Math.min(1, progress * 3);
                this.animationState.value = progress;
                return this.parentElement;
            }
        }];
    }
}

export const elements = {
    VennDiagram,
};
